'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMessageId = undefined;

var _reselect = require('reselect');

var _getIsAdmin = require('../clientSelectors/getIsAdmin');

var _getWidgetData = require('../widgetDataSelectors/getWidgetData');

var getMessageId = exports.getMessageId = (0, _reselect.createSelector)([_getWidgetData.getWidgetData, _getIsAdmin.getIsAdmin], function (widgetData, isAdmin) {
  if (isAdmin) return null;
  return widgetData.message.id;
});


//////////////////
// WEBPACK FOOTER
// ./js/selectors/pubNubMessageSelectors/getMessageId.js
// module id = 344
// module chunks = 2 3